














import {Vue, Component, Prop, Emit} from 'vue-property-decorator'

@Component({})
export default class Select extends Vue {
  @Prop() value: any

  private isActive: boolean = false
}
